import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { getDisplayInformation } from '../components/data-driven-logo/get-display-information';

export const useMarketplaceDisplayNameFromStoreGuid = (storeGuid) => {
  const stores = useSelector(Global.selectSellerActiveStores);
  const store = stores.find((s) => s.storeGuid === storeGuid);
  const marketplaceId = store?.marketplaceId;
  const displayInformation = getDisplayInformation({ marketplaceId });
  return displayInformation?.name ?? '';
};
